/**
 * A share, always with its denominator: "201 of 312 (64%)". The only way the report renders a
 * percentage, so a bare one cannot appear. Floored, never rounded, as the server reports coverage:
 * 221 of 312 is 70%, not 71%, so a share never reads as more than it is.
 */
export const ratioText = (numerator: number, denominator: number): string => {
  if (denominator <= 0) {
    return `${numerator.toLocaleString('en-US')} of ${denominator.toLocaleString('en-US')}`;
  }
  // Multiplied before dividing, as the server does: 29 / 100 * 100 is 28.999… in floating point.
  const percent = Math.floor((numerator * 100) / denominator);
  return `${numerator.toLocaleString('en-US')} of ${denominator.toLocaleString('en-US')} (${percent}%)`;
};
